module.exports = ".boxedLookup ::ng-deep div.ng-value {\n    white-space: nowrap !important;\n    padding: 0 0 0 7px !important;\n}"